module.exports = __webpack_public_path__ + "static/media/car-metro-monochrome-svgrepo-com.280a95b4.svg";